/**
 * 참고: https://github.kakaocorp.com/kakaopage/api/blob/ad75ae912870621c23e6659954e59b4314020c8a/mysql/src/main/java/com/kakaopage/mysql/pageservice/entity/api/SeriesProductVO.java#L71
 */

export enum BusinessModelVo {
  /**
   * 일반
   */
  Normal = 'T',
  /**
   * 웹시리즈
   */
  Web = 'P',
  /**
   * 복합BM
   */
  Mix = 'M',
}
